import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import moment from "moment";

const ArriendoDataTable = ({
    flattenedDataArriendo,
    setFlattenedDataArriendo,
    loading,
    cotizacion,
    desde,
    hasta,
    idCotizacion,
    idCliente,
    servicios,
    setServicios,
    setDesde,
    setHasta,
    setLoading,
    handleTablaChange,
    postUpdateDataCotizacion,
    updateCotizacion,
    handleNewTramoArriendo,
    handleBorrarLinea,
    showConfirmDialogArriendo,
    setShowConfirmDialogArriendo,
    tramosConfirmationIndex,
    handleTramoConfirmationArriendo,
    showProductForm,
    setShowProductForm,
    handleAddToProduct,
    cobroOptionsFlattened,
    monedaOptions,
    subtotalArriendo,
    products,
    showTramoModalArriendo,
    setShowTramoModalArriendo,
    nombreCuadro,
    setNombreCuadro,
    tramos,
    tramoCounter,
    selectFechaTramo,
    dateFormats
    }) => {

    return (
        <>
        {/* HEAD */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px", }}>
            <h5>TARIFA MENSUAL (OPEX)</h5>
        </div>
        
        {/* BODY */}
        <DataTable
            value={
            Array.isArray(flattenedDataArriendo) ? flattenedDataArriendo : []
            }
            className="p-datatable-gridlines mt-2 mb-4"
            showGridlines
            header={`Arriendo`}
            loading={loading}
            emptyMessage={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '.5rem' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.25rem' }}></i>
                    <span>Cargando items...</span>
                </div>
            }
            sortMode="single"
            onSort={(e) => {
            const sorted = [...e.data].sort((a, b) => {
                const getKey = (desc) => {
                if (desc.includes('modulo-')) {
                    const part = desc.split('-')[1];
                    return part ? part.charAt(0) : desc;
                }
                return desc;
                };
                return getKey(a.descripcion).localeCompare(getKey(b.descripcion));
            });
            setFlattenedDataArriendo(sorted);
            }}
        >
            {/* columna activo */}
            <Column
                field="es_union"
                header="Estado"
                body={(rowData) => (
                <>
                    <div>
                        {rowData.es_union ? (
                        <Button
                            icon="pi pi-link"
                            className="p-button-rounded p-button-secondary p-button"
                            outlined
                            tooltip="Producto Combinado"
                            tooltipOptions={{ position: 'top' }}
                        />
                        ) : (
                        <Button
                            icon="pi pi-check"
                            className="p-button-rounded p-button-success p-button"
                            outlined
                            tooltip="Producto Individual"
                            tooltipOptions={{ position: 'top' }}
                        />
                        )}
                    </div>
                </>
                )}
            />

            <Column 
            field="descripcion" 
            header="Nombre" 
            />
        

            <Column
            field="tramo"
            header="Tramo"
            body={(rowData) => (rowData.tramo === "null" ? "" : rowData.tramo)}
            />

            <Column
            header="Fecha Desde"
            body={(rowData) => {
                return (
                <Calendar
                    style={{ width: "100%", minWidth: "100px" }}
                    value={moment(rowData.desde, "YYYY-MM-DD", true).toDate()}
                    dateFormat="dd/mm/yy"
                    disabled={
                    (rowData.tramo && rowData.tramo.includes("Tramo")) ||
                    cotizacion?.estado.estado === "ASIGNACIÓN" || 
                    cotizacion?.estado.estado === "ANULADA" || 
                    !rowData.descripcion.includes("Modulo") || cotizacion?.estado.estado === "RECHAZADA"
                    }
                    
                    onChange={(e) => {
                    const newDate = moment(e.value, "YYYY-MM-DD", true);

                    if (newDate.isValid()) {
                        const isOutsideRange =
                        newDate.isBefore(moment(desde, "YYYY-MM-DD", true)) ||
                        newDate.isAfter(moment(hasta, "YYYY-MM-DD", true));

                        if (isOutsideRange) {
                            async function handleUpdateAndReload() {
                                setLoading(true);

                                const desdeTransformed = newDate.format("YYYY-MM-DD");
                                const hastaTransformed = moment(rowData.hasta,"YYYY-MM-DD",true).format("YYYY-MM-DD");

                                await handleTablaChange(
                                rowData,
                                desdeTransformed,
                                "flattened",
                                "desde"
                                );

                                await postUpdateDataCotizacion({ ...rowData, desde: desdeTransformed },false);

                                await updateCotizacion(
                                    idCotizacion,
                                    idCliente,
                                    cotizacion?.estado?.id_estado,
                                    sessionStorage.getItem("usuario_id"),
                                    desdeTransformed,
                                    hastaTransformed,
                                    cotizacion?.aviso
                                );

                                const baseUrl = window.location.href.split("/#/")[0];
                                const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${hastaTransformed}`;
                                const fullUrl = `${baseUrl}/#${urlAVolver}`;
                                setDesde(desdeTransformed);
                                setHasta(hastaTransformed);
                                window.location.href = fullUrl;
                                setLoading(false);
                            }
                            handleUpdateAndReload();
                        } else {
                            async function handleReload() {
                            setLoading(true);

                            const desdeTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(
                            rowData,
                            desdeTransformed,
                            "flattened",
                            "desde"
                            );

                            await postUpdateDataCotizacion({ ...rowData, desde: desdeTransformed },false);

                            const updatedItems = flattenedDataArriendo.map(
                            (item) =>
                                item.id === rowData.id
                                ? { ...item, desde: desdeTransformed }
                                : item
                            );

                            const allDesdeDates = [
                            ...updatedItems.map((item) =>
                                moment(item.desde, "YYYY-MM-DD", true)
                            ),
                            ...servicios.map((item) =>
                                moment(item.desde, "YYYY-MM-DD", true)
                            ),
                            ];

                            const currentMinDesde = moment.min(allDesdeDates);

                            let currentDesde;

                            if (desde) {
                                currentDesde = moment(desde, "YYYY-MM-DD", true);
                                if (!currentDesde.isValid()) {
                                    console.warn("Attempting to parse currentHasta with alternate format (DD/MM/YYYY)");
                                    currentDesde = moment(desde, "DD/MM/YYYY", true);
                                }
                            } else {
                                console.error("cotizacion.hasta is undefined or null.");
                            }

                            if (currentDesde && currentMinDesde.isValid() && currentMinDesde.isValid()) {
                                if (!currentMinDesde.isSame(currentDesde, "day")) {
                                    const hastaTransformed = moment(rowData.hasta,"YYYY-MM-DD",true).format("YYYY-MM-DD");

                                    await updateCotizacion(
                                        idCotizacion,
                                        idCliente,
                                        cotizacion?.estado?.id_estado,
                                        sessionStorage.getItem("usuario_id"),
                                        currentMinDesde.format("YYYY-MM-DD"),
                                        hastaTransformed,
                                        cotizacion?.aviso
                                    );
                                    
                                    const baseUrl = window.location.href.split("/#/")[0];

                                    const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${currentMinDesde.format(
                                    "YYYY-MM-DD"
                                    )}&hasta=${hastaTransformed}`;
                                    const fullUrl = `${baseUrl}/#${urlAVolver}`;
                                    setDesde(currentMinDesde.format("YYYY-MM-DD"));
                                    setHasta(hastaTransformed);
                                    window.location.href = fullUrl;
                                    setLoading(false);
                                } else {
                                    console.log("Dates are the same; no update needed.");
                                }
                            }

                            setLoading(false);
                            }
                        handleReload();
                        }
                    }
                    }}
                    minDate={moment(desde, "YYYY-MM-DD", true).toDate()}
                    maxDate={moment(hasta, "YYYY-MM-DD", true).toDate()}
                />
                );
            }}
            />

            <Column
            header="Fecha Hasta"
            body={(rowData) => {
                return (
                <Calendar
                    style={{ width: "100%", minWidth: "100px" }}
                    value={moment(rowData.hasta, "YYYY-MM-DD", true).toDate()}
                    dateFormat="dd/mm/yy"
                    disabled={
                    (rowData.tramo && rowData.tramo.includes("Tramo")) ||
                    cotizacion?.estado.estado === "ASIGNACIÓN" ||
                    cotizacion?.estado.estado === "ANULADA" || 
                    cotizacion?.estado.estado === "RECHAZADA"
                    }
                    onChange={(e) => {
                    const newDate = moment(e.value, "YYYY-MM-DD", true);
                    
                    if (newDate.isValid()) {
                        const isOutsideRange = newDate.isBefore(moment(desde, "YYYY-MM-DD", true)) || newDate.isAfter(moment(hasta, "YYYY-MM-DD", true));

                        if (isOutsideRange) {
                            async function handleUpdateAndReload() {
                            setLoading(true);

                            const desdeTransformed = moment(rowData.desde,"YYYY-MM-DD",true).format("YYYY-MM-DD");
                            const hastaTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(rowData,hastaTransformed,"flattened","hasta");

                            await postUpdateDataCotizacion({ ...rowData, hasta: hastaTransformed },false);

                            const serviciosActualizados = await Promise.all(
                            servicios.map(async (item) => {
                                if (item.descripcion.includes(rowData.descripcion)) {
                                    const actualizado = { ...item, hasta: hastaTransformed };
                                    await handleTablaChange(actualizado, hastaTransformed, "servicios", "hasta");
                                    await postUpdateDataCotizacion(actualizado, false);
                                    return actualizado;
                                }
                                return item;
                            })
                            );
                            setServicios(serviciosActualizados);

                            await updateCotizacion(
                                idCotizacion,
                                idCliente,
                                cotizacion?.estado?.id_estado,
                                sessionStorage.getItem("usuario_id"),
                                desdeTransformed,
                                hastaTransformed,
                                cotizacion?.aviso
                            );
                            const baseUrl = window.location.href.split("/#/")[0];

                            const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${hastaTransformed}`;
                            const fullUrl = `${baseUrl}/#${urlAVolver}`;
                            setDesde(desdeTransformed);
                            setHasta(hastaTransformed);
                            window.location.href = fullUrl;
                            setLoading(false);
                        }

                        handleUpdateAndReload();
                        } else {
                            async function handleReload() {
                            setLoading(true);

                            const hastaTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(
                                rowData,
                                hastaTransformed,
                                "flattened",
                                "hasta"
                            );

                            await postUpdateDataCotizacion(
                                { ...rowData, hasta: hastaTransformed },
                                false
                            );

                            const serviciosActualizados = await Promise.all(
                                servicios.map(async (item) => {
                                    if (
                                        item.descripcion.includes(rowData.descripcion)
                                    ) {
                                        const actualizado = { ...item, hasta: hastaTransformed };
                                        await handleTablaChange(actualizado, hastaTransformed, "servicios", "hasta");
                                        await postUpdateDataCotizacion(actualizado, false);
                                        return actualizado;
                                    }
                                    return item;
                                    })
                                );
                                setServicios(serviciosActualizados);

                                const updatedItems = flattenedDataArriendo.map(
                                (item) =>
                                    item.id === rowData.id
                                    ? { ...item, hasta: hastaTransformed }
                                    : item
                                );

                                const allHastaDates = [
                                ...updatedItems.map((item) =>
                                    moment(item.hasta, "YYYY-MM-DD", true)
                                ),
                                ...servicios.map((item) =>
                                    moment(item.hasta, "YYYY-MM-DD", true)
                                ),
                            ];

                            const currentMaxHasta = moment.max(allHastaDates);

                            let currentHasta;

                                if (hasta) {
                                currentHasta = moment(hasta, "YYYY-MM-DD", true);

                                if (!currentHasta.isValid()) {
                                    console.warn(
                                    "Attempting to parse currentHasta with alternate format (DD/MM/YYYY)"
                                    );
                                    currentHasta = moment(hasta, "DD/MM/YYYY", true);
                                }
                                } else {
                                console.error(
                                    "cotizacion.hasta is undefined or null."
                                );
                                }

                                if (
                                currentHasta &&
                                currentMaxHasta.isValid() &&
                                currentHasta.isValid()
                                ) {
                                if (!currentMaxHasta.isSame(currentHasta, "day")) {
                                    const desdeTransformed = moment(
                                    rowData.desde,
                                    "YYYY-MM-DD",
                                    true
                                    ).format("YYYY-MM-DD");

                                    await updateCotizacion(
                                    idCotizacion,
                                    idCliente,
                                    cotizacion?.estado?.id_estado,
                                    sessionStorage.getItem("usuario_id"),
                                    desdeTransformed,
                                    currentMaxHasta.format("YYYY-MM-DD"),
                                    cotizacion?.aviso
                                    );
                                    const baseUrl =
                                    window.location.href.split("/#/")[0];

                                    const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${currentMaxHasta.format(
                                    "YYYY-MM-DD"
                                    )}`;
                                    const fullUrl = `${baseUrl}/#${urlAVolver}`;
                                    setDesde(desdeTransformed);
                                    setHasta(currentMaxHasta.format("YYYY-MM-DD"));
                                    window.location.href = fullUrl;
                                    setLoading(false);
                                } else {
                                    console.log(
                                    "Dates are the same; no update needed."
                                    );
                                }
                                }

                                setLoading(false);
                            }

                            handleReload();
                            }
                        }
                        }}
                        minDate={moment(desde, "YYYY-MM-DD", true).add(1, 'day').toDate()}
                        maxDate={rowData.descripcion.toLowerCase().includes('modulo') ? (() => {
                        const partes = rowData.descripcion.split(' - ');
                        if (partes.length <= 1) return moment(hasta, "YYYY-MM-DD", true).toDate();
                        const nombreProducto = partes[1].trim();
                        const productoEncontrado = products.find(p => p.descripcion.toLowerCase() === nombreProducto.toLowerCase());
                        return productoEncontrado ? moment(productoEncontrado.hasta, "YYYY-MM-DD", true).toDate() : moment(hasta, "YYYY-MM-DD", true).toDate();
                        })() : undefined}
                    />
                    );
                }}
                />

                <Column
                header="Documento Cobro"
                body={(rowData) => (
                    <Dropdown
                    value={rowData.cobro}
                    options={cobroOptionsFlattened}
                    onChange={(e) =>
                        handleTablaChange(rowData, e.value, "flattened", "cobro")
                    }
                    optionLabel="label"
                    optionValue="value"
                    placeholder={rowData.cobro}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" || 
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                )}
                />

                <Column
                header="Tipo"
                body={(rowData) =>
                    rowData.tipo === "Incluido" ? "Incluido" : "Adicional"
                }
                />

                <Column
                header="Medida"
                body={(rowData) => (
                    <span>
                    {rowData.unidad === "m**2" ? (
                        <>
                        m
                        <sup>2</sup>
                        </>
                    ) : (
                        rowData.unidad
                    )}
                    </span>
                )}
                />

                <Column 
                header="Cantidad" 
                field="cantidad" 
                />

                <Column
                header="Tarifa Base"
                field="tarifa_base"
                maxFractionDigits={4}
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                body={(rowData) => (
                    <span>
                    {rowData?.tarifa_base?.toFixed(2).toString().replace(".", ",")}{" "}
                    UF
                    </span>
                )}
                />

                <Column
                header="Moneda"
                body={(rowData) => {
                    const filteredOptions = monedaOptions.filter(
                    (item) => item.idEmpresa === rowData.id_empresa
                    );

                    return (
                    <Dropdown
                        value={rowData.moneda}
                        options={filteredOptions}
                        onChange={(e) =>
                        handleTablaChange(rowData, e.value, "flattened", "moneda")
                        }
                        optionLabel="codigo"
                        optionValue="codigo"
                        placeholder={rowData.moneda}
                        disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                            cotizacion?.estado.estado === "ANULADA" || 
                            cotizacion?.estado.estado === "RECHAZADA"
                        }
                    />
                    );
                }}
                />

                <Column
                header="Tarifa Cliente"
                body={(rowData) => (
                    <InputNumber
                    value={rowData.tarifa_cliente}
                    onChange={(e) => { handleTablaChange(rowData, e.value, "flattened", "tarifa_cliente");}}
                    locale="es-CL"
                    mode="decimal"
                    maxFractionDigits={5}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" || 
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                    )}
                />

                <Column
                header="Descuento Tarifa %"
                field="descuento"
                body={(rowData) => (
                    <>
                    {rowData.moneda === "UF" ? (
                        <>
                        <InputNumber
                            value={
                            isFinite(rowData.descuento) ? rowData.descuento : 0
                            }
                            onChange={(e) => { handleTablaChange(rowData, e.value, "flattened", "descuento");}}
                            locale="es-CL"
                            mode="decimal"
                            maxFractionDigits={4}
                            disabled={
                            rowData.tarifa_base === 0 ||
                            cotizacion?.estado.estado === "ASIGNACIÓN" ||
                            cotizacion?.estado.estado === "ANULADA" || 
                            cotizacion?.estado.estado === "RECHAZADA"
                            }
                            style={{ 
                            fontWeight: rowData.isMask ? 'bold' : 'normal'
                            }}
                        />
                        </>
                    ) : (
                        <>
                        <InputNumber
                            value={0}
                            onChange={(e) => { handleTablaChange(rowData, e.value, "flattened", "descuento");}}
                            locale="es-CL"
                            mode="decimal"
                            maxFractionDigits={4}
                            disabled
                        />
                        </>
                    )}
                    </>
                )}
                />

                <Column
                header="Tarifa Diaria"
                field="tarifa_diaria"
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                body={(rowData) =>
                    rowData.tarifa_diaria === "Tarifa Variable"
                    ? rowData.tarifa_diaria
                    : rowData.tarifa_diaria
                    ? parseFloat(rowData.tarifa_diaria).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        }) + " UF"
                    : ""
                }
                />

                <Column
                header="Tarifa Mensual"
                field="tarifa_mensual"
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                body={(rowData) =>
                    rowData.tarifa_mensual === "Tarifa Variable"
                    ? rowData.tarifa_mensual
                    : rowData.tarifa_mensual
                    ? parseFloat(rowData.tarifa_mensual).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        }) + " UF"
                    : ""
                }
                />

                {cotizacion?.estado.estado !== "ASIGNACIÓN" && (
                <Column
                    header="Acción"
                    style={{ minWidth: "120px" }}
                    body={(rowData) => (
                    <>
                        <>
                            <Button
                                icon="pi pi-plus"
                                className="p-button-rounded p-button-success p-button mr-2"
                                label=""
                                onClick={() => handleNewTramoArriendo(rowData)}
                                disabled={
                                rowData?.tramo && rowData?.tramo.includes("Tramo") ||
                                cotizacion?.estado.estado === "ANULADA" ||
                                cotizacion?.estado.estado === "ASIGNACIÓN" || 
                                cotizacion?.estado.estado === "RECHAZADA" 
                                }
                                outlined
                            />
                            <Button
                                icon="pi pi-trash"
                                className="p-button-rounded p-button-danger p-button"
                                label=""
                                onClick={() => handleBorrarLinea(rowData, "productos")}
                                outlined
                                disabled={loading ||
                                cotizacion?.estado.estado === "ANULADA" ||
                                cotizacion?.estado.estado === "ASIGNACIÓN" || 
                                cotizacion?.estado.estado === "RECHAZADA"
                                }
                            />
                        </>

                        <Dialog
                            visible={showTramoModalArriendo}
                            onHide={() => {
                                setShowTramoModalArriendo(false);
                            }}
                            className="p-dialog p-dialog-responsive"
                            modal
                            dismissableMask={false}
                            header={`Seleccione tramos a generar para ${nombreCuadro}`}
                        >
                        <div className="flex align-items-center justify-content-center">
                            <div className="grid">
                                <div className="col-12">
                                    <div>
                                        {tramos.map((tramo, index) => (
                                            <div
                                            key={index}
                                            className="p-fluid formgrid grid"
                                            >
                                            <div className="field col-12 md:col-4">
                                                <label htmlFor={`descripcionSubP_${index}`}>
                                                Tramo {index + 1}
                                                </label>
                                                <InputText
                                                id={`descripcionSubP_${index}`}
                                                value={tramo.descripcion}
                                                disabled
                                                onChange={(e) => setNombreCuadro(e.value)}
                                                />
                                            </div>
                                            <div className="field col-12 md:col-4">
                                                <label htmlFor={`desde_${index}`}>
                                                Desde
                                                </label>
                                                <Calendar
                                                id={`desde_${index}`}
                                                showIcon
                                                value={moment(
                                                tramo.desde,
                                                dateFormats,
                                                true
                                                ).toDate()}
                                                onChange={(e) => {}}
                                                minDate={
                                                    moment(
                                                    tramo.desde,
                                                    dateFormats,
                                                    true
                                                    ).isValid()
                                                    ? moment(tramo.desde, dateFormats, true)
                                                        .add(1, "days")
                                                        .toDate()
                                                    : new Date()
                                                }
                                                maxDate={moment(
                                                    tramo.hasta,
                                                    dateFormats,
                                                    true
                                                ).toDate()}
                                                dateFormat="dd/mm/yy"
                                                disabled={true}
                                                />
                                            </div>
                                            <div className="field col-12 md:col-4">
                                                <label htmlFor={`hasta_${index}`}>
                                                Hasta
                                            </label>
                                            <Calendar
                                                id={`hasta_${index}`}
                                                showIcon
                                                value={moment(
                                                    tramo.hasta,
                                                    dateFormats,
                                                    true
                                                ).toDate()}
                                                onChange={(e) => {
                                                    selectFechaTramo(
                                                    index,
                                                    moment(
                                                        e.value,
                                                        dateFormats,
                                                        true
                                                    ).toDate()
                                                    );
                                                }}
                                                minDate={
                                                    moment(
                                                    tramo.desde,
                                                    dateFormats,
                                                    true
                                                    ).isValid()
                                                    ? moment(tramo.desde, dateFormats, true)
                                                        .add(1, "days")
                                                        .toDate()
                                                    : new Date()
                                                }
                                                maxDate={moment(
                                                    tramo.hasta,
                                                    dateFormats,
                                                    true
                                                ).toDate()}
                                                dateFormat="dd/mm/yy"
                                                disabled={index !== tramoCounter}
                                            />
                                            </div>
                                        </div>
                                        ))}
                                        <div className="justify-content-end">
                                            <Button
                                                icon={loading ? "pi pi-spinner" : "pi pi-save"}
                                                label={`Confirmar`}
                                                className="p-button-rounded p-button-success p-button mt-2"
                                                onClick={() => handleTramoConfirmationArriendo(nombreCuadro) }
                                                disabled={loading}
                                                raised
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                    </>
                )}
                />
            )}
        </DataTable>

        {/* FOOTER */}
        <div className="grid ml-2 mr-2 mb-4" style={{display: "flex",alignItems: "center",justifyContent: "center",}}>
            <div className="pink-color">
            <strong>Arriendo Promedio Mensual:</strong>{" "}
                {subtotalArriendo.toLocaleString("en-US").replace(".", ",")} UF
            </div>
        </div>

        {/* Dialogs */}
        <Dialog
        header="Confirmar eliminación"
        visible={showConfirmDialogArriendo}
        style={{ width: "450px" }}
        modal
        footer={
            <div>
                <Button
                    label="No"
                    icon="pi pi-times"
                    onClick={() => setShowConfirmDialogArriendo(false)}
                    className="p-button-text"
                />
                <Button
                    label="Sí"
                    icon="pi pi-check"
                    onClick={() => handleTramoConfirmationArriendo(tramosConfirmationIndex)}
                    autoFocus
                />
            </div>
        }
        onHide={() => setShowConfirmDialogArriendo(false)}>
        <div className="confirmation-content">
            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }}/><span>¿Estás seguro de que quieres eliminar este tramo?</span>
        </div>
        </Dialog>

        {/* Dialog para crear producto */}
        <Dialog
            header="Crear Producto"
            visible={showProductForm}
            style={{ width: "800px" }}
            modal
            onHide={() => setShowProductForm(false)}
            footer={
                <div>
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => setShowProductForm(false)} className="p-button-text"
                    />
                    <Button label="Agregar" icon="pi pi-check" onClick={handleAddToProduct} autoFocus
                    />
                </div>
            }
        />
        </>
    );
};

export default ArriendoDataTable;